import React from "react";
import { Paper, Typography, Button, Grid } from "@material-ui/core";
import ScheduleItem from "./ScheduleItem";
import ScheduleInstanceItem from "./ScheduleInstanceItem";
import moment from "moment";

function ScheduleContainer({
  classes,
  zone,
  zoneId,
  setSelectedSchedule,
  setDrawerScheduleOpen,
  setDrawerQuickScheduleOpen,
  schedules,
  onActivate,
  loading,
  onEditSchedule,
  onDeleteSchedule,
  onStopInstance,
  onDeleteInstance,
  schedulesInstances,
}) {
  //const [hover, sethover] = useState(false);

  return (
    <Paper className={classes.container}>
      <Typography className={classes.containerTitle}>{zone}</Typography>
      {schedules &&
        schedules.map((schedule, index) => {
          let instance = (schedulesInstances || []).find((item) => item.scheduleId === schedule.id);

          return (
            <ScheduleItem
              key={"schedule_" + index}
              schedule={{ ...schedule, zoneId }}
              onEditSchedule={onEditSchedule}
              onDeleteSchedule={onDeleteSchedule}
              onStopInstance={onStopInstance}
              onActivate={onActivate}
              instance={instance}
              loading={loading}
            />
          );
        })}
      {schedulesInstances &&
        schedulesInstances
          .filter((instance) => instance.scheduleId === "" && instance.zoneId === zoneId)
          .map((instance, index) => {
            return (
              <ScheduleInstanceItem
                key={"schedule_instance_" + index}
                instance={instance}
                onStopInstance={onStopInstance}
                onDeleteInstance={onDeleteInstance}
              />
            );
          })}
      <Grid container spacing={1}>
        <Grid item>
          <Button
            variant="contained"
            size="small"
            color="primary"
            onClick={() => {
              setSelectedSchedule({ zoneId });
              setDrawerScheduleOpen(true);
            }}
          >
            Add Schedule
          </Button>
        </Grid>
        <Grid item>
          {" "}
          <Button
            variant="contained"
            size="small"
            color="secondary"
            onClick={() => {
              setSelectedSchedule({ zoneId, startDate: moment(new Date()) });
              setDrawerQuickScheduleOpen(true);
            }}
          >
            Add Quick Schedule
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
}

export default ScheduleContainer;
